<template>
  <div>
    <v-icon class="red--text">mdi-menu-right</v-icon>
    {{ "sentence.your_material"|globalTranslate }}
    <div class="d-inline-block mx-2">
      <v-menu
          v-model="dateMenu"
          :close-on-content@-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              id="date-selector"
              v-model="date"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker @input="changeDate" v-model="date" locale="fr-FR" show-current></v-date-picker>
      </v-menu>
    </div>
    {{ "for"|globalTranslate }}
    <div class="d-inline-block mx-2">
      <v-select
          class="select-nb-days"
          id="number-of-days-selector"
          @input="changeNumberOfDays"
          v-model="numberOfDays"
          :items="numberOfDaysChoices"
          :placeholder="'placeholder_day'|globalTranslate"
          item-text="label"
          item-value="value"
          dense
          hide-details
          required>
      </v-select>
    </div>
    {{ "day"|globalTranslate }} <b>({{ "7_day_is_free"|globalTranslate }})</b>.
    <div class="red--text mt-2">
      <v-icon class="red--text">mdi-menu-right</v-icon>
      <a href="https://auptitpingouin.sport2000.fr/fr/"
         target="_blank">{{ 'sentence.sport200_booking'|globalTranslate }}</a>
    </div>
  </div>
</template>

<script>

import Config from "@/config";
import {mapGetters} from "vuex";

export default {
  name: "DateAndQtySelection",
  computed: {
    ...mapGetters({
      getNumberOfDays: "cart/getNumberOfDays",
      getDate: "cart/getDate"
    })
  },
  created() {
    this.numberOfDays = this.getNumberOfDays();
    this.date = this.getDate();

    // Build dropdown nb days
    let count = 1;
    while (Config.MAX_DAYS >= count) {
      this.numberOfDaysChoices.push({
        label: count.toString(),
        value: count
      });
      count++;
    }
  },
  data() {
    return {
      date: {},
      dateMenu: false,
      numberOfDays: 1,
      numberOfDaysChoices: []
    }
  },
  methods: {
    changeNumberOfDays() {
      this.$store.dispatch("cart/changeNumberOfDays", this.numberOfDays);
    },
    changeDate() {
      this.dateMenu = false;
      this.$store.dispatch("cart/saveDate", this.date);
    }
  }
}
</script>

<style scoped>
.select-nb-days {
  max-width: 70px;
}
</style>
